import { SegmentsState } from 'types/segments/segments.types';
import {
  CLEAR_SEGMENT_STATE,
  CREATE_SEGMENT_FAILURE,
  CREATE_SEGMENT_REQUEST,
  CREATE_SEGMENT_SUCCESS,
  DELETE_SEGMENT_FAILURE,
  DELETE_SEGMENT_REQUEST,
  DELETE_SEGMENT_SUCCESS,
  GET_SEGMENT_CONTACTS_FAILURE,
  GET_SEGMENT_CONTACTS_REQUEST,
  GET_SEGMENT_CONTACTS_SUCCESS,
  GET_SEGMENT_FAILURE,
  GET_SEGMENT_REQUEST,
  GET_SEGMENT_SUCCESS,
  GET_SEGMENTS_FAILURE,
  GET_SEGMENTS_REQUEST,
  GET_SEGMENTS_SUCCESS,
  SegmentsActionTypes,
  UPDATE_SEGMENT_FAILURE,
  UPDATE_SEGMENT_REQUEST,
  UPDATE_SEGMENT_SUCCESS,
  UPLOAD_SEGMENT_CONTACTS_FAILURE,
  UPLOAD_SEGMENT_CONTACTS_REQUEST,
  UPLOAD_SEGMENT_CONTACTS_SUCCESS,
  EXPORT_SEGMENT_CONTACTS_REQUEST,
  EXPORT_SEGMENT_CONTACTS_SUCCESS,
  EXPORT_SEGMENT_CONTACTS_FAILURE,
  CLEAR_EXPORT_SEGMENT_CONTACTS_SUCCESS,
  REMOVE_CONTACT_FROM_SEGMENT_REQUEST,
  REMOVE_CONTACT_FROM_SEGMENT_SUCCESS,
  REMOVE_CONTACT_FROM_SEGMENT_FAILURE,
  CLEAR_REMOVE_CONTACT_FROM_SEGMENT_SUCCESS,
  ADD_CONTACTS_TO_SEGMENT_REQUEST,
  ADD_CONTACTS_TO_SEGMENT_SUCCESS,
  ADD_CONTACTS_TO_SEGMENT_FAILURE,
  CLEAR_ADD_CONTACTS_TO_SEGMENT_SUCCESS,
} from './segments.types';

const initialState: SegmentsState = {
  segments: [],
  selectedSegment: null,
  loading: false,
  error: null,
  success: false,
  contacts: [],
  contactsLoading: false,
  contactsError: null,
  contactsPagination: {
    page: 0,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
  pagination: {
    page: 0,
    limit: 10,
    total: 0,
    totalPages: 0,
  },
  exportBlobLoading: false,
  exportBlob: null,
  removeContactLoading: false,
  removeContactError: null,
  removeContactSuccess: false,
  addContactsToSegmentLoading: false,
  addContactsToSegmentError: null,
  addContactsToSegmentSuccess: false,
};

const segmentsReducer = (
  state: SegmentsState = initialState,
  action: SegmentsActionTypes
): SegmentsState => {
  switch (action.type) {
    case GET_SEGMENTS_REQUEST:
    case GET_SEGMENT_REQUEST:
    case CREATE_SEGMENT_REQUEST:
    case UPDATE_SEGMENT_REQUEST:
    case DELETE_SEGMENT_REQUEST:
    case UPLOAD_SEGMENT_CONTACTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case ADD_CONTACTS_TO_SEGMENT_REQUEST:
      return {
        ...state,
        addContactsToSegmentLoading: true,
        addContactsToSegmentError: null,
        addContactsToSegmentSuccess: false,
      };

    case REMOVE_CONTACT_FROM_SEGMENT_REQUEST:
      return {
        ...state,
        removeContactLoading: true,
        removeContactError: null,
        removeContactSuccess: false,
      };

    case GET_SEGMENT_CONTACTS_REQUEST:
      return {
        ...state,
        contactsLoading: true,
        contactsError: null,
      };

    case EXPORT_SEGMENT_CONTACTS_REQUEST:
      return {
        ...state,
        exportBlobLoading: true,
        error: null,
      };

    case GET_SEGMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        segments: action.payload.segments,
        pagination: action.payload.pagination,
        error: null,
      };

    case GET_SEGMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        selectedSegment: action.payload,
        error: null,
      };

    case CREATE_SEGMENT_SUCCESS:
    case UPDATE_SEGMENT_SUCCESS:
      const existingIndex = state.segments.findIndex(
        (segment) => segment._id === action.payload._id
      );

      if (existingIndex !== -1) {
        // Update existing contact
        return {
          ...state,
          loading: false,
          segments: state.segments.map((segment) =>
            segment._id === action.payload._id ? action.payload : segment
          ),
          selectedSegment: action.payload,
          error: null,
          success: true,
        };
      } else {
        // Add new contact
        return {
          ...state,
          loading: false,
          segments: [action.payload, ...state.segments],
          selectedSegment: action.payload,
          success: true,
          error: null,
        };
      }

    case DELETE_SEGMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        segments: state.segments.filter(
          (segment) => segment._id !== action.payload
        ),
        selectedSegment:
          state.selectedSegment?._id === action.payload
            ? null
            : state.selectedSegment,
        error: null,
      };

    case GET_SEGMENTS_FAILURE:
    case GET_SEGMENT_FAILURE:
    case CREATE_SEGMENT_FAILURE:
    case UPDATE_SEGMENT_FAILURE:
    case DELETE_SEGMENT_FAILURE:
    case UPLOAD_SEGMENT_CONTACTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case ADD_CONTACTS_TO_SEGMENT_FAILURE:
      return {
        ...state,
        addContactsToSegmentLoading: false,
        addContactsToSegmentError: action.payload,
        addContactsToSegmentSuccess: false,
      };

    case REMOVE_CONTACT_FROM_SEGMENT_FAILURE:
      return {
        ...state,
        removeContactLoading: false,
        removeContactError: action.payload,
        removeContactSuccess: false,
      };
    case GET_SEGMENT_CONTACTS_FAILURE:
      return {
        ...state,
        contactsLoading: false,
        contactsError: action.payload,
        contacts: [],
      };
    case CLEAR_SEGMENT_STATE:
      return {
        ...state,
        success: false,
        error: null,
      };
    case UPLOAD_SEGMENT_CONTACTS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case ADD_CONTACTS_TO_SEGMENT_SUCCESS:
      return {
        ...state,
        addContactsToSegmentLoading: false,
        addContactsToSegmentSuccess: true,
        addContactsToSegmentError: null,
      };
    case REMOVE_CONTACT_FROM_SEGMENT_SUCCESS:
      return {
        ...state,
        removeContactLoading: false,
        removeContactSuccess: true,
        removeContactError: null,
        contacts: state.contacts.filter(
          (contact) => contact._id !== action.payload
        ),
        contactsPagination: {
          ...state.contactsPagination,
          total: Math.max(0, state.contactsPagination.total - 1),
        },
      };

    case CLEAR_REMOVE_CONTACT_FROM_SEGMENT_SUCCESS:
      return {
        ...state,
        removeContactSuccess: false,
      };
    case GET_SEGMENT_CONTACTS_SUCCESS:
      return {
        ...state,
        contactsLoading: false,
        contacts: action.payload.contacts,
        contactsPagination: action.payload.pagination,
        contactsError: null,
      };

    case EXPORT_SEGMENT_CONTACTS_SUCCESS:
      return {
        ...state,
        exportBlobLoading: false,
        exportBlob: action.payload,
        error: null,
      };

    case EXPORT_SEGMENT_CONTACTS_FAILURE:
      return {
        ...state,
        exportBlobLoading: false,
        error: action.payload,
      };

    case CLEAR_EXPORT_SEGMENT_CONTACTS_SUCCESS:
      return {
        ...state,
        exportBlob: null,
        exportBlobLoading: false,
      };

    case CLEAR_ADD_CONTACTS_TO_SEGMENT_SUCCESS:
      return {
        ...state,
        addContactsToSegmentSuccess: false,
      };

    default:
      return state;
  }
};

export default segmentsReducer;
